import React, { useEffect, useState } from "react";
import { useGlobalValue } from "../../../state/GlobalProvider";
import { formatValueByType } from "../../../utils";
import styles from "./BalanceSheetChart.module.sass";
import { setParsedCurrency } from "../../../utils/format";
const FinancialReportChartLegend = props => {
  const {
    data,
    dynamicCurrency
  } = props;
  const [currency, setCurrency] = useState({
    locale: undefined,
    currency: false
  });
  const {
    kpis = [],
    label
  } = data || {};
  const {
    i18n
  } = useGlobalValue();
  const componentLabel = label || "";
  useEffect(() => {
    setParsedCurrency(null, dynamicCurrency, setCurrency);
  }, [dynamicCurrency]);
  return /*#__PURE__*/React.createElement("div", {
    className: styles["legend"]
  }, /*#__PURE__*/React.createElement("div", null, (kpis || []).map((kpi, index) => {
    const {
      name,
      value,
      type
    } = kpi || {};
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: styles["value-container"]
    }, /*#__PURE__*/React.createElement("small", {
      className: styles["label"]
    }, i18n`${name}`), /*#__PURE__*/React.createElement("h5", null, formatValueByType(value, type, currency)));
  }), componentLabel && /*#__PURE__*/React.createElement("div", {
    className: styles["value-container"]
  }, /*#__PURE__*/React.createElement("small", {
    className: styles["label"]
  }, `${componentLabel}`), /*#__PURE__*/React.createElement("div", {
    className: styles["legend-line"]
  }))));
};
export default FinancialReportChartLegend;